import axios from 'axios'

axios.interceptors.request.use((config) => {
    config.headers['Authorization'] = 'Bearer ' + window.localStorage.getItem('access_token')
    // These headers prevent IE 11 from caching GET requests
    config.headers['Cache-Control'] = 'no-cache'
    config.headers['Pragma'] = 'no-cache'
    return config
})

export default axios
